import baseApi from '@/modules/services/base';
import { ThemeDefaultTag, ThemeTag, ThemesTag } from './tags';
import { ThemeDataType, ThemeFormDataType } from '@/modules/types/theme';
import { PaginationParams, PaginationType } from '../types/elearning';

const themesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDefaultTheme: build.query<ThemeDataType, void>({
      query: () => `themes/default`,
      providesTags: [ThemeDefaultTag],
    }),
    getThemes: build.query<
      PaginationType<ThemeDataType>,
      void | PaginationParams
    >({
      query: (params) =>
        params ? { url: 'themes', params } : { url: 'themes' },
      providesTags: [ThemesTag],
    }),
    getTheme: build.query<ThemeDataType, string>({
      query: (themeId) => `themes/${themeId}`,
      providesTags: [ThemeTag],
    }),
    createTheme: build.mutation<ThemeDataType, ThemeFormDataType>({
      query: (data) => ({
        url: `themes`,
        method: 'POST',
        body: data,
        responseType: 'json',
      }),
      invalidatesTags: [ThemeTag, ThemesTag],
    }),
    deleteTheme: build.mutation<any, string>({
      query: (id) => ({
        url: `themes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ThemeTag, ThemesTag],
    }),
    updateTheme: build.mutation<ThemeDataType, ThemeDataType>({
      query: (data) => ({
        url: `themes/${data.id}`,
        method: 'PUT',
        body: data,
        responseType: 'json',
      }),
      invalidatesTags: [ThemeTag, ThemesTag],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetThemesQuery,
  useGetThemeQuery,
  useGetDefaultThemeQuery,
  useCreateThemeMutation,
  useDeleteThemeMutation,
  useUpdateThemeMutation,
} = themesApi;

export default themesApi;
